import {diApiNa} from '@di-shared/api/di';
import {PermissionTypeEu} from '@di-shared/api/di/type';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';
import {getQueryKey} from '@shared/queryKeyMap';
import {useSuspenseQuery} from '@tanstack/react-query';

export default function useAvailableComponentNa({vin}: {vin: string}) {
  const {data: vehicleInfo} = useSuspenseQuery({
    queryKey: [getQueryKey(diApiNa.vehicle.getVehicleInfo), vin],
    queryFn: () => diApiNa.vehicle.getVehicleInfo({vin}),
    select: ({data}) => data,
    ...DEFAULT_CACHE_TIME,
  });

  function checkAvailableComponent(permissionType: keyof typeof PermissionTypeEu) {
    switch (permissionType) {
      case 'SAFETY_SCORE':
      case 'TRIPS':
      case 'EV_ENERGY_USAGE':
      case 'TIRE_PRESSURE':
      case 'EV_BATTERY':
        return isSupportFeature(permissionType);
      default:
        return false;
    }
  }

  function isSupportFeature(permissionType: keyof typeof PermissionTypeEu) {
    return vehicleInfo.supportedFeatures.includes(permissionType);
  }

  const isUbiAvailable = vehicleInfo.availableSelectiveTerms.includes('UBI');
  const isUbiAgreed = vehicleInfo.consentedTerms.some((term) => term.termsCode === 'UBI' && term.consent);

  return {
    checkAvailableComponent,
    isSupportFeature,
    isUbiAvailable,
    isUbiAgreed,
  };
}
